import { FlexProps } from "@chakra-ui/layout";
import { Box } from "@chakra-ui/react";
import React from "react";
import Card from "../Card";

type DocumentCardProps = FlexProps & {
  color?: string;
};
const DocumentCard: React.FC<DocumentCardProps> = ({
  color,
  children,
  ...rest
}) => {
  return (
    <Card
      w="100%"
      h="100px"
      borderRadius="20px"
      {...rest}
      align="center"
      justify="space-between"
      boxShadow="dark-lg"
      pr={5}
    >
      <Box
        h="inherit"
        borderTopLeftRadius="inherit"
        borderBottomLeftRadius="inherit"
        w="5%"
        bg={color ? color : "#66ccff"}
      ></Box>
      <Box w="95%">{children}</Box>
    </Card>
  );
};

export default DocumentCard;
